import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "latest-message" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 1,
    class: "ai-message-view-mode"
};
const _hoisted_4 = { class: "ai-message-display" };
const _hoisted_5 = { class: "edit-controls" };
const _hoisted_6 = { class: "radio-group-container" };
import { ref, onMounted, watch } from "vue";
import { createMessageDto } from "@/dtos/messageDto";
import useMessage from "@/composables/message/useMessage";
import useSuperAdminUser from "@/composables/useSuperAdminUser";
const AI_API_URL = 'https://907pffivf4.execute-api.ap-northeast-1.amazonaws.com/prod/';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageForm',
    props: {
        toUserId: {}
    },
    emits: ["sent"],
    setup(__props, { emit: __emit }) {
        const { storeMessages, latestMessage, fetchByUserIds } = useMessage();
        const { superAdminUser, fetchSuperAdminUser } = useSuperAdminUser();
        const props = __props;
        const emits = __emit;
        const chatMessage = ref('');
        const aiMessage = ref('');
        const aiSource = ref('guide');
        const userType = ref('planner');
        const isLoading = ref(false);
        const isEditing = ref(false);
        const originalMessageText = ref('');
        // 直近のメッセージが変更されたときに、メッセージフォームの内容を更新
        watch(latestMessage, (newMessage) => {
            if (superAdminUser.value) {
                if (newMessage && newMessage.fromUserId !== superAdminUser.value.id) {
                    aiMessage.value = newMessage.text;
                    originalMessageText.value = newMessage.text;
                }
            }
        });
        // 初期化時にメッセージを取得
        onMounted(async () => {
            await fetchSuperAdminUser();
            if (superAdminUser.value) {
                await fetchByUserIds(superAdminUser.value.id, props.toUserId);
                if (latestMessage.value && latestMessage.value.fromUserId !== superAdminUser.value.id) {
                    aiMessage.value = latestMessage.value.text;
                    originalMessageText.value = latestMessage.value.text;
                }
            }
        });
        const startEditing = () => {
            isEditing.value = true;
        };
        const saveEditing = () => {
            isEditing.value = false;
            originalMessageText.value = aiMessage.value;
        };
        const cancelEditing = () => {
            isEditing.value = false;
            aiMessage.value = originalMessageText.value;
        };
        const generateAIResponse = async () => {
            if (isLoading.value)
                return;
            // ここで値を確認
            console.log('aiMessage.value:', aiMessage.value);
            if (!aiMessage.value) {
                window.alert('AIに送信するメッセージが空です。');
                return;
            }
            isLoading.value = true;
            try {
                const response = await fetch(AI_API_URL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        key: aiSource.value === 'guide' ? (userType.value === 'planner' ? 'guide/guide_planner.json' : 'guide/guide_company.json') : 'history/chat_history.json',
                        question: aiMessage.value,
                        source: aiSource.value,
                        userType: userType.value === 'planner' ? 'planner' : 'company'
                    })
                });
                if (!response.ok) {
                    throw new Error('AI回答の生成に失敗しました');
                }
                const data = await response.json();
                chatMessage.value = data.response || '回答の生成に失敗しました';
            }
            catch (error) {
                console.error('AI回答生成エラー:', error);
                window.alert('AI回答の生成に失敗しました。');
            }
            finally {
                isLoading.value = false;
            }
        };
        const sendMessage = async () => {
            if (!superAdminUser.value) {
                window.alert('運営者ユーザーの取得に失敗しています。');
                return;
            }
            const m = createMessageDto(superAdminUser.value.id, props.toUserId, chatMessage.value, '');
            try {
                await storeMessages([m]);
            }
            catch (e) {
                window.alert('メッセージの送信に失敗しました。');
                console.error(e);
                return;
            }
            chatMessage.value = '';
            emits('sent');
        };
        return (_ctx, _cache) => {
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_form = _resolveComponent("v-form");
            return (_openBlock(), _createBlock(_component_v_form, null, {
                default: _withCtx(() => [
                    _createElementVNode("p", null, "送信元: " + _toDisplayString(_unref(superAdminUser)?.name), 1),
                    _createVNode(_component_v_textarea, {
                        modelValue: chatMessage.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((chatMessage).value = $event)),
                        label: "メッセージ"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                        color: "primary",
                        onClick: sendMessage,
                        disabled: isLoading.value,
                        class: "mb-4"
                    }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("メッセージを送信")
                        ])),
                        _: 1,
                        __: [4]
                    }, 8, ["disabled"]),
                    _createElementVNode("div", _hoisted_1, [
                        (!isEditing.value)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "AIに送信する質問文"))
                            : _createCommentVNode("", true),
                        (!isEditing.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("p", _hoisted_4, _toDisplayString(aiMessage.value), 1),
                                _createVNode(_component_v_btn, {
                                    color: "primary",
                                    size: "small",
                                    onClick: startEditing,
                                    class: "ml-2"
                                }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode(" 編集 ")
                                    ])),
                                    _: 1,
                                    __: [5]
                                })
                            ]))
                            : _createCommentVNode("", true),
                        (isEditing.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_v_textarea, {
                                    modelValue: aiMessage.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((aiMessage).value = $event)),
                                    label: "AIに送信するメッセージ",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": ""
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_v_btn, {
                                        color: "success",
                                        size: "small",
                                        onClick: saveEditing,
                                        class: "mr-2"
                                    }, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode(" 保存 ")
                                        ])),
                                        _: 1,
                                        __: [6]
                                    }),
                                    _createVNode(_component_v_btn, {
                                        color: "error",
                                        size: "small",
                                        onClick: cancelEditing
                                    }, {
                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode(" キャンセル ")
                                        ])),
                                        _: 1,
                                        __: [7]
                                    })
                                ])
                            ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_radio_group, {
                            modelValue: aiSource.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((aiSource).value = $event)),
                            label: "AI回答の情報ソース",
                            class: "radio-group-item",
                            density: "compact"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                    label: "ガイドから",
                                    value: "guide"
                                }),
                                _createVNode(_component_v_radio, {
                                    label: "過去のやり取りから",
                                    value: "history"
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_v_radio_group, {
                            modelValue: userType.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((userType).value = $event)),
                            label: "ユーザータイプ",
                            class: "radio-group-item",
                            density: "compact"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                    label: "プランナー",
                                    value: "planner"
                                }),
                                _createVNode(_component_v_radio, {
                                    label: "クライアント",
                                    value: "client"
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_v_btn, {
                        color: "secondary",
                        onClick: generateAIResponse,
                        disabled: isLoading.value,
                        class: "mt-4"
                    }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("生成AIで回答を作成する")
                        ])),
                        _: 1,
                        __: [8]
                    }, 8, ["disabled"])
                ]),
                _: 1
            }));
        };
    }
});
